'use strict';

/**
 *
 * @name: nownessApp.user
 *
 */

import UserConfig from './user.config';
import UserRun from './user.run';

import PermissionsFactory from './permissions.factory';
import UserAnalyticsFactory from './user-analytics.factory';

import ActionFollowDirective from './DEPRECATED-action-follow.directive';
import FollowUnfollowDirective from './follow-unfollow.directive';

const UserModule = angular
  .module('nownessApp.user', [
    'nownessApp.api',
  ])
  .config(UserConfig)
  .run(UserRun)
  .factory('permissions', PermissionsFactory)
  .factory('userAnalytics', UserAnalyticsFactory)
  .directive('actionFollow', ActionFollowDirective)
  .directive('followUnfollow', FollowUnfollowDirective)

export default UserModule.name;



// WEBPACK FOOTER //
// ./app/pages/user/user.module.js